import { type TransferListKind } from '@/models/domain/inventory-transfer'

/**
 * Paths for Incoming and Received Transfers. Each list has its own detail
 * route, so the sidebar marks the list a transfer was opened from and the
 * detail page knows where Back goes, even when the transfer fails to load.
 */
export const INCOMING_TRANSFERS_PATH = '/admin/inventory/transfers'
export const RECEIVED_TRANSFERS_PATH = '/admin/inventory/received-transfers'

function listBase(kind: TransferListKind): string {
  return kind === 'received' ? RECEIVED_TRANSFERS_PATH : INCOMING_TRANSFERS_PATH
}

// The location chosen on a list rides along as `?location=`, so the list
// reopens on it and a transfer opened from it knows where Back goes.
function withLocation(path: string, location: string): string {
  if (!location) return path
  return `${path}?location=${encodeURIComponent(location)}`
}

/** A transfer list, opened on a location when one is given. */
export function transferListPath(kind: TransferListKind, location = ''): string {
  return withLocation(listBase(kind), location)
}

/**
 * A transfer, opened from a list filtered to `location`. Back returns to that
 * list and location, not to the transfer's own destination: the two can
 * differ, and Back should go where the user came from (web-portal#94).
 */
export function transferDetailPath(
  kind: TransferListKind,
  transferId: string,
  location = ''
): string {
  return withLocation(`${listBase(kind)}/${encodeURIComponent(transferId)}`, location)
}
